import { CommonModule } from '@angular/common';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { NgModule } from '@angular/core';

import { ButtonModule } from '../../notes/button/button.module';
import { ModalModule } from '../../notes/modal/modal.module';

import { SessionTimerComponent } from './session-timer.component';
import { SessionTimerService } from './session-timer.service';

@NgModule({
  declarations: [SessionTimerComponent],
  exports: [SessionTimerComponent],
  imports: [CommonModule, ButtonModule, ModalModule],
  providers: [SessionTimerService, provideHttpClient(withInterceptorsFromDi())],
})
export class SessionTimerModule {}
